type NotifyFn = (message: string) => void;

const bridge: { notify: NotifyFn | null } = { notify: null };

export function registerToastNotifier(fn: NotifyFn) {
  bridge.notify = fn;
}

export function notifyError(message: string) {
  bridge.notify?.(message);
}
